import { Group, Stack } from '@mantine/core';
import { UserAvatar } from '@repo/common/components';
import { Text } from '@repo/foundations';
import { memo } from 'react';
import type { IQuestion } from '../../api';
import { formatShortTimeDifference } from '../../utils/time';

export const QuestionTitleCell = memo(({ record }: { record: IQuestion }) => (
	<Group spacing="sm" noWrap>
		<UserAvatar size="sm" user={record.display_metadata?.owners?.[0] ?? {}} />
		<Stack spacing={0} miw={0}>
			<Text size="sm" weight="bold" truncate>
				{record.title}
			</Text>
			<Text size="xs" color="text/secondary/default">
				Asked by{' '}
				{record.display_metadata?.owners?.[0]?.display_name ?? 'Unknown'} ·{' '}
				{formatShortTimeDifference(record.created_at, false, false)}
			</Text>
		</Stack>
	</Group>
));
